import React from 'react';
import { render } from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import configureStore from './store/configureStore'; // eslint-disable-line import/default
import { loadCustomer } from './actions/customerActions';
import '@coxautokc/fusion-theme/dist/fusion-theme.min.css'; // eslint-disable-line
import App from './components/App';

const store = configureStore();

// Make necessary calls to retrieve initial data...
store.dispatch(loadCustomer());

// Don't need React Router?
// Reference your top level component directly instead of <Router> and the child <Route> below
render(
  <Provider store={store}>
    <Router className="main-layout">
      <div>
        <Route path="/" component={App} />
      </div>
    </Router>
  </Provider>,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js